import React from "react";
import { Routes, Route } from 'react-router-dom';
import Dashboard from "../pages/dashboard/Dashboard";
import Login from "../pages/login/Login"
import WaitingPage from "../pages/Waiting/WaitingPage";
import FacilitySearch from "../pages/FacilitySeacrch/FacilitySeach";
import SalesCenterTesting from "../../src/pages/facilityTesting/SalesCenterTesting";
import CreateReservation from "../pages/reservation/CreateReservation";
import ManageReservation from "../pages/reservation/manageReservation/ManageReservation";
import ReservationConfirmation from "../pages/reservation/ReservationConfirmation";
import useScrollToTop from '../components/Common/ScrollToTop';
import AppLayout from '../layouts/Applayouts/Applayout';
import ProtectedRoute from '../components/Common/ProtectedRoute';
import RentalConfirmation from "../pages/rent/RentalConfirmation";
import RentAndReservationRent from "../pages/rent/RentAndReservationRent";

const AppRoutes: React.FC = () => {
    useScrollToTop();
    return (
        <Routes>
            <Route element={<AppLayout />}>
                <Route path="/" element={<Login />} />
                <Route
                    path="/Dashboard/:facilityid"
                    element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    }
                />
                <Route path="/WaitingPage" element={
                    <ProtectedRoute>
                        <WaitingPage />
                    </ProtectedRoute>
                }
                />
                <Route path="/Facility"
                    element={
                        <ProtectedRoute>
                            <FacilitySearch />
                        </ProtectedRoute>
                    }
                />
                <Route path="/TestOperator"
                    element={
                        <ProtectedRoute>
                            <SalesCenterTesting />
                        </ProtectedRoute>
                    }
                />
                <Route path="/CreateReservation" element={
                    <ProtectedRoute>
                        <CreateReservation />
                    </ProtectedRoute>
                }
                />
                <Route path="/ManageReservation/:facilityId/:externalId" element={
                    <ProtectedRoute>
                        <ManageReservation />
                    </ProtectedRoute>
                } />
                
                <Route path="/ReservationConfirmation" element={
                    <ProtectedRoute>
                        <ReservationConfirmation />
                    </ProtectedRoute>
                } />
                <Route path="/rent/:facilityid/unit/:externalUnitId/promo/:promotionId" element={
                    <ProtectedRoute>
                       <RentAndReservationRent type={1} />
                    </ProtectedRoute>
                } />

                <Route path="/rent/:facilityid/deal/:reservationId" element={
                    <ProtectedRoute>
                       <RentAndReservationRent type={2} />
                    </ProtectedRoute>
                } />

                <Route path="/RentalConfirmation" element={
                    <ProtectedRoute>
                        <RentalConfirmation />
                    </ProtectedRoute>
                } />
            </Route>
        </Routes>
        
    );
};

export default AppRoutes;